module.exports = __webpack_public_path__ + "static/media/clap-bw-neg.199ef8dc.svg";